import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import { Link } from 'react-admin'
import { FlexBox } from 'shared/components/Base/Base'
import { Text } from 'shared/components/Text/Text'
import { getJobConsoleStatusDetail, JobStatusDetail, JobStatusDetailColorMap } from 'shared/models/job'
import { errorD1, midGray, primaryBlack, white } from 'shared/theme/colors'
import styled from 'styled-components'

import {
  BrokerCategoryKey,
  BrokerCreditRatingCategory,
  BrokerCreditRatingFontColor,
  Job,
} from '../../../models/jobs'

interface JobDetailsTopInfoProps {
  job: Job
}

export function JobDetailsTopInfo({ job }: JobDetailsTopInfoProps) {
  const brokerCreditRating = isNaN(parseInt(job.load.broker?.credit_rating))
    ? null
    : job.load.broker?.credit_rating
  const brokerApproved = job.load.broker?.status === 'APPROVED' ?? false
  const carrierSetupCompleted = job.load.broker?.is_carrier_packet_complete ?? false
  const creditRatingColor = job.load.broker
    ? BrokerCreditRatingFontColor[job.load.broker.credit_rating_category[BrokerCategoryKey.CREDIT_RATING]]
    : BrokerCreditRatingFontColor[BrokerCreditRatingCategory.UNDETERMINED]

  return (
    <FlexBox isFullWidth>
      <FlexBox isColumn flex={1}>
        <FlexBox alignItems="center" gap="4px">
          <Text variant="label4" fontColor={midGray}>
            Job
          </Text>
          <Text variant="header4" fontColor={primaryBlack}>
            {job.human_id}
          </Text>
        </FlexBox>
        <Text variant="header6" fontColor={JobStatusDetailColorMap[job.status_detail]}>
          {getJobConsoleStatusDetail(job.status_detail)}
          {[JobStatusDetail.REQUESTED_CANCELLATION, JobStatusDetail.CANCELED].includes(
            job.status_detail as JobStatusDetail
          ) && ` - ${job.is_request_cancellation_late ? 'late' : 'not late'}`}
        </Text>
      </FlexBox>
      <FlexBox isColumn flex={1}>
        <FlexBox alignItems="center" gap="4px">
          <Text variant="label4" fontColor={midGray}>
            Broker ID
          </Text>
          <Text variant="header4" fontColor={primaryBlack}>
            {job.load.source_human_id || '-'}
          </Text>
        </FlexBox>
        <FlexBox isColumn>
          <FlexBox alignItems="center" gap="8px">
            <Link to={`/brokers/${job.load.broker?.id}/show`}>
              <Text variant="header3" fontColor={primaryBlack}>
                {job.load.broker?.name}
              </Text>
            </Link>
            <Text variant="label3" fontColor={creditRatingColor}>
              {brokerCreditRating}
            </Text>
            {brokerApproved && (
              <Text variant="label3" fontColor={creditRatingColor}>
                ✓
              </Text>
            )}
            {carrierSetupCompleted && (
              <Text variant="label3" fontColor={creditRatingColor}>
                ✓
              </Text>
            )}
          </FlexBox>
          <FlexBox alignItems="center" gap="16px">
            {!brokerApproved && (
              <FlexBox gap="4px" alignItems="center">
                <StyledErrorOutlineIcon htmlColor={errorD1} />
                <Text variant="label4" fontColor={errorD1}>
                  not approved
                </Text>
              </FlexBox>
            )}
            {!carrierSetupCompleted && (
              <FlexBox gap="4px" alignItems="center">
                <StyledErrorOutlineIcon htmlColor={errorD1} />
                <Text variant="label4" fontColor={errorD1}>
                  carrier setup
                </Text>
              </FlexBox>
            )}
          </FlexBox>
        </FlexBox>
      </FlexBox>
    </FlexBox>
  )
}

const StyledErrorOutlineIcon = styled(ErrorOutlineIcon)`
  width: 16px;
  height: 16px;
  background-color: ${white};
  border-radius: 50%;
`
